import { AxiosError } from "axios";

export const CLINIC_REQUEST_EXPIRED_ERROR_CODE = "clinic_request_expired";

export const isClinicRequestExpiredError = (error: unknown): boolean => {
  if (!(error instanceof AxiosError)) return false;
  const data = error.response?.data as
    | {
        detail?: { code?: string };
      }
    | undefined;
  return data?.detail?.code === CLINIC_REQUEST_EXPIRED_ERROR_CODE;
};
